import { render, staticRenderFns } from "./switch-business.vue?vue&type=template&id=724a566a&scoped=true&"
import script from "./switch-business.vue?vue&type=script&lang=js&"
export * from "./switch-business.vue?vue&type=script&lang=js&"
import style0 from "./switch-business.vue?vue&type=style&index=0&id=724a566a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724a566a",
  null
  
)

export default component.exports